import React, { Component } from 'react';
import { tsv, timeParse, nest, sum } from 'd3';

import Header from '../Header/Header';
import Intro from '../Intro/Intro';
import Controls from '../Controls/Controls';
import Agenda from '../Agenda/Agenda';
import BarChart from '../BarChart/BarChart';
import Donut from '../Donut/Donut';
//import BillboardChart from '../BillboardChart/BillboardChart';
import Footer from '../Footer/Footer';


import './App.css';


class App extends Component {

  state = {
    showAdmin: true,
    data: {},
    colors: {
      'admin': '#f5821f',
      'apotheker': '#009bdf',
      'psychiater': '#f58220',
      'ziekenhuisverpleegkundige': '#006cb7',
      'wijkverpleegkundige': '#ffc20e',
      'mdl-arts': '#ed1b34',
      'fysiotherapeut': '#92278f',
      'nonAdmin': '#fff',
      'dag': '#fff',
      'lichtgroen': '#6cccad',
    },
    showProfession: 'apotheker',
    professions: [],
    level: 'detail'
  }

  componentWillMount() {
    tsv(process.env.PUBLIC_URL + '/data/apothekers.tsv', (error, result) => {
      this.processData(result, 'apotheker');
    });
    tsv(process.env.PUBLIC_URL + '/data/fysiotherapeuten.tsv', (error, result) => {
      this.processData(result, 'fysiotherapeut');
    });
    tsv(process.env.PUBLIC_URL + '/data/mdl-artsen.tsv', (error, result) => {
      this.processData(result, 'mdl-arts');
    });
    tsv(process.env.PUBLIC_URL + '/data/psychiaters.tsv', (error, result) => {
      this.processData(result, 'psychiater');
    });
    tsv(process.env.PUBLIC_URL + '/data/wijkverpleegkundigen.tsv', (error, result) => {
      this.processData(result, 'wijkverpleegkundige');
    });
    tsv(process.env.PUBLIC_URL + '/data/verpleegkundigen.tsv', (error, result) => {
      this.processData(result, 'ziekenhuisverpleegkundige');
    });
  }

  updateShow = () => {
    const { showAdmin, showProfession, data } = this.state;
    const dataDonut = data[showProfession].dataDonut;
    dataDonut.hide = showAdmin ? ['admin'] : [];
    this.setState({ showAdmin: !showAdmin, dataDonut });
  }

  changeProfession = (profession) => {
     this.setState({ showProfession: profession });
  }

  changeLevel = () => {
    const level = this.state.level;
    const newLevel = level === 'detail' ? 'hoofd' : 'detail';
    this.setState({ level: newLevel });
  }

  formatValue = (minutes) =>{
    const hours = Math.floor(minutes/60);
    let rest = minutes - (hours * 60);
    if (rest < 10) rest = '0' + rest;
    return minutes < 60 ? minutes + ' min' : hours + ':' + rest + ' uur';
  }

  createDataBars = (data, column, profession) => {
    const rollupData = nest()
      .key(d => d.categorie)
      .key(d => { return d[column] === '' || d[column] === 'Onbekend' || d[column] === undefined  ? 'Onbekend' : d[column] })
      .rollup(values => sum(values, d => Math.round(d.seconds/60)))
        .entries(data)
        .filter(d => d.key === 'admin')[0].values
        .sort((a,b) => b.value - a.value);

    return rollupData;

  }

  processData = (input, profession) => {
    const { data, professions } = this.state;

    // create agenda data
    const parseTime = timeParse("%H:%M:%S");
    const dataAgenda = input.map(row => {
      const seconds =  (parseTime(row.eind) - parseTime(row.start))/(1000);
      row.seconds = seconds;
      if (seconds < 0) console.log(row)
      row.nested = row.nested === "TRUE" ? true : false;
      row.weekdag = row.weekdag.toLowerCase();
      return row;
    })

    // create dataDonut
    const rollupTime = nest()
      .key(d => d.categorie)
      .rollup(values => sum(values, d => Math.round(d.seconds/60)))
      .map(input)

    const totaleWerktijd = rollupTime.get('niet-admin');
    const administratie = rollupTime.get('admin');

    const dataDonut = [
      { key: 'admin', value: administratie, fraction: administratie/totaleWerktijd },
      { key: 'niet-admin', value: totaleWerktijd - administratie, fraction: (totaleWerktijd - administratie)/totaleWerktijd}
    ];


    // create dataWho
    const dataWho = this.createDataBars(input, 'wieHoofd', profession)
    const dataWhoDetail = this.createDataBars(input, 'wieDetail', profession)

    // create dataWhy
    const dataWhy = this.createDataBars(input, 'waaromHoofd', profession)
    const dataWhyDetail = this.createDataBars(input, 'waaromDetail', profession)

    // create dataWhat
    const dataWhat = this.createDataBars(input, 'wat', profession)

    data[profession] = {  dataAgenda, dataDonut, dataWho, dataWhoDetail, dataWhy, dataWhyDetail, dataWhat };
    professions.push(profession);

    this.setState({ data, professions });

  }

  render() {

    const { data, colors, professions, showAdmin, showProfession } = this.state;

    if (!data.apotheker) return null;

    const percentageAdmin = Math.round(100*data[showProfession].dataDonut[0].fraction);
    const hoursAdmin = Math.round(data[showProfession].dataDonut[0].value/60);
    const legendaColors = {
      'apotheker': 'Blauw',
      'psychiater': 'Oranje',
      'ziekenhuisverpleegkundige': 'Blauw',
      'wijkverpleegkundige': 'Geel',
      'mdl-arts': 'Rood',
      'fysiotherapeut': 'Paars'
    }

    // const dataWho = this.state.level === 'detail' ? 'dataWhoDetail' : 'dataWho';
    // const dataWhy = this.state.level === 'detail' ? 'dataWhyDetail' : 'dataWhy';

    return (
      <div className="App">

        <Header />

        <div className="container">

          <div className="row">
            <Intro />
            <Controls
              showAdmin={showAdmin}
              updateShow={this.updateShow}
              changeProfession={this.changeProfession}
              professions={professions}
              changeLevel={this.changeLevel}
              level={this.state.level}
            />
          </div>

          <div className="subheader row">
            <h1>Hoe ziet de gemiddelde weekagenda van een {showProfession} eruit?</h1>
          </div>

          <div className="row">

            <div className="panel col-md-4">
              <h4>Welk deel van de werktijd besteedt een {showProfession} aan administratie?</h4>
              <div className="labelAdmin" style={ {backgroundColor: colors[showProfession]} }>
                <p>Administratieve taken {percentageAdmin}%</p>
                <p>{hoursAdmin} uur per week</p>
              </div>
             <Donut
                height={300}
                data={data[showProfession].dataDonut}
                colors={ { 'admin': colors[showProfession], 'niet-admin': '#fff' } }
                format={this.formatValue}
              />
              <div className="labelNonAdmin">
                Niet-administratieve taken {100-percentageAdmin}%
              </div>
            </div>

            <div className="panel col-md-8">
              <h4>Op welke momenten in de werkweek doet een {showProfession} administratie?</h4>
              <Agenda
                height={600}
                colors={colors}
                showAdmin={showAdmin}
                data={data[showProfession].dataAgenda}
                showProfession={showProfession}
              />
              <div className="boxLegenda">
                <p>Wit is werktijd</p>
                <p>{legendaColors[showProfession]} is administratie</p>
              </div>
            </div>

          </div>

          <div className="row">

            <div className="panel what col-lg-6">
              <h4>Welke administratieve handelingen verricht een {showProfession} en hoeveel tijd kosten deze?</h4>
              <BarChart
                data={this.state.data[showProfession].dataWhat}
                margin={{ top: 30, right: 30, bottom: 10, left: 280 }}
                barHeight={26}
                domain={[0,700]}
                color={ {fill: colors[showProfession], stroke: '#fff'} }
                unit=" minuten"
                format={this.formatValue}
                title={showProfession}
              />
              <div className="boxTotal">
                <p>Totaal</p>
                <p>{hoursAdmin} uur</p>
                <p>per week</p>
              </div>
            </div>

          <div className="col-lg-6">

            <div className="panel who row">
              <h4>Wat zijn de partijen voor wie een {showProfession} administratie doet en hoeveel tijd kost dit?</h4>
              <BarChart
                data={this.state.data[showProfession].dataWhoDetail}
                margin={{ top: 30, right: 30, bottom: 10, left: 280 }}
                barHeight={26}
                domain={[0,700]}
                color={ {fill: colors[showProfession], stroke: '#fff'} }
                format={this.formatValue}
                title={showProfession}
              />
              <div className="boxTotal">
                <p>Totaal</p>
                <p>{hoursAdmin} uur</p>
                <p>per week</p>
              </div>
            </div>

            <div className="panel why row">
              <h4>Wat zijn de redenen waarom een {showProfession} administratie doet en hoeveel tijd kost dit?</h4>
              <BarChart
                data={this.state.data[showProfession].dataWhyDetail}
                margin={{ top: 30, right: 30, bottom: 10, left: 280 }}
                barHeight={26}
                domain={[0,700]}
                color={ {fill: colors[showProfession], stroke: '#fff'} }
                format={this.formatValue}
                title={showProfession}
              />
              <div className="boxTotal">
                <p>Totaal</p>
                <p>{hoursAdmin} uur</p>
                <p>per week</p>
              </div>
            </div>

          </div>

        </div>

        </div>

        <Footer />

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.js